import React from "react";
import classNames from "classnames";
import { useClasses } from "..";
const styles = (theme) => ({
    wrapper: {
        overflowX: "scroll",
        "-ms-overflow-style": "none,",
        scrollbars: "none",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
            display: "none",
        },
    },
    table: {
        borderCollapse: "collapse",
        width: "100%",
    },
    th: {
        border: "1px solid " + theme.palette.get("grey"),
        padding: "8px 16px",
    },
    td: {
        border: "1px solid " + theme.palette.get("grey"),
        padding: "4px 8px",
    },
    odd: {
        backgroundColor: "#fff",
    },
    even: {
        backgroundColor: theme.palette.get("formBackground"),
    },
});
export default function Table(props) {
    const classes = useClasses(styles, props);
    const { columns, data } = props;
    return (React.createElement("div", { className: classes.wrapper },
        React.createElement("table", { className: classes.table },
            React.createElement("thead", null,
                React.createElement("tr", null, columns.map((item, index) => (React.createElement("th", { key: `thead-${index}`, className: classNames([classes.th, classes.odd, item.classes]) }, item.label))))),
            React.createElement("tbody", null, data.map((row, index) => (React.createElement("tr", { key: `trow-${index}`, className: index % 2 ? classes.odd : classes.even }, columns.map((col, i) => (React.createElement("td", { key: `tdata-${i}`, className: classNames([classes.td, col.classes]) }, typeof row[col.field] !== "undefined" &&
                row[col.field] !== null
                ? row[col.field]
                : "-"))))))))));
}
